export default '/static/frontend/ReachDigital/12gobiking/dist/assets/klarna-pay-later-fi-aa4c8368.svg'